import React, {useEffect, useState} from 'react';
import {useNavigate} from "react-router-dom";
import {getDiscountedProducts} from "../api/HomeApi";
import Loading from "../../../layouts/Loading";

import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import {showError} from "../../../utils/toastHelper";
import offer from "../../../assets/images/offer.svg"
import {MdOutlineBookmark} from "react-icons/md";


const DiscountedProducts = () => {

    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const config = window.APP_CONFIG;
    const currencyFormat = Intl.NumberFormat('en-US');

    const [discountedProducts, setDiscountedProducts] = React.useState([]);
    useEffect(() => {
        const fetchProducts = async () => {
            try {

                const params = {
                    count: 8,
                    list: 1,
                    vendor: localStorage.getItem('_vid')
                }
                const data = await getDiscountedProducts(params);
                setDiscountedProducts(data?.data || []);
            } catch (err) {
                showError( err);
            } finally {
                setLoading(false);
            }
        };
        fetchProducts();
    }, []);



    if (!Array.isArray(discountedProducts) || discountedProducts.length === 0) return null;
    
    if (loading) return <Loading />;
    return (
        <div className="container my-4 bg-third-color py-3 discounted-products">


            <Swiper
                modules={[Navigation]}
                navigation
                spaceBetween={1}     // فاصله بین آیتم‌ها
                slidesPerView={2.2}   // بسته به عرض کارت‌ت ممکنه 2.1 یا 3.2 مناسب باشه
                breakpoints={{
                    576: { slidesPerView: 2.5 },
                    768: { slidesPerView: 3.2 },
                    992: { slidesPerView: 4 },
                }}
            >
                <SwiperSlide>
                    <div className="row text-center mt-5 text-white">
                        <div className='col-12'>
                            <img src={offer} style={{width:'100px'}} alt="offer"/>
                        </div>
                        <div className='col-12 mt-3'>
                            <h2 className='fw-bold'>
                                تخفیف ویژه
                            </h2>
                        </div>
                        <div className='col-12 mt-3 text-small-2'>
                            به مدت محدود!
                        </div>
                    </div>
                </SwiperSlide>
                {discountedProducts.map((product, index) => (
                    <SwiperSlide key={product.id}>

                        <div className="row vendor-product m-1"
                             style={ {
                                 'borderRadius' : !index ? '0 8px 8px 0' : '0'
                             }}
                        >
                            <div className="col-12 text-center mt-3"
                                 onClick={
                                     () => {
                                         navigate(`/product/${product.id}`)

                                     }
                                 }
                            >
                                {
                                    product.vendor_price?.discount_percent > 0 &&
                                    <div className='discount-percent'>
                                                    <span
                                                        className='badge badge-info badge-pill bg-primary-color  text-small-3'>
                                                    {product?.vendor_price?.discount_percent}
                                                        &nbsp;

                                                        %

                                                </span>
                                    </div>
                                }
                                {
                                    product.is_favorite > 0 ?
                                        <MdOutlineBookmark className='me-3  text-big-4 text-third-color float-start'

                                        />
                                        :
                                        ''
                                }
                                <div className="clearfix"></div>
                                <img src={product.image} alt={product.name} className='w-50'/>

                            </div>
                            <div className="col-12 text-center text-small-2 mt-3" onClick={
                                () => {
                                    navigate(`/product/${product.id}`)
                                }
                            }>
                                {product.name.substring(0, 30)}
                            </div>

                            <div className="col-12 ">
                                {product.vendor_price?.price ?
                                    <div className=" text-start mt-3 mb-2 text-muted fw-bold text-small-1">

                                        {
                                            product.vendor_price?.discount_percent > 0 && !product.price_range ?
                                                <div
                                                    className='text-decoration-line-through fw-normal text-small-3 opacity-50 '>
                                                    {currencyFormat.format(product.vendor_price?.price)}
                                                    &nbsp;
                                                    {config.currency}
                                                </div> :
                                                <div
                                                    className='text-decoration-line-through fw-normal text-small-3 opacity-50'>
                                                    &nbsp;
                                                </div>

                                        }

                                        <div>
                                            {

                                                !product.price_range ?
                                                    <span className='text-small-2'>
                                                                {currencyFormat.format(product.vendor_price?.discounted_price)}
                                                            </span>
                                                    :
                                                    <span className='text-small-2'>{product.price_range}</span>
                                            }
                                            &nbsp;
                                            <span className='text-small-3 text-muted'>
                                                            {config.currency}
                                                    </span>
                                        </div>


                                    </div>
                                    : ''
                                }
                            </div>



                        </div>

                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    );
};


export default DiscountedProducts;